import React from 'react';

/**
 * Isolates one optional section of the client document so a fault inside it can
 * NEVER blank the whole proposal/contract. If children throw for any reason,
 * this renders NOTHING — the section is simply absent, exactly as it is for a
 * client with no add-ons. No error text, no red box, no apology to the client.
 * The failure is logged so we can see it.
 */
export class SectionErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    try {
      // eslint-disable-next-line no-console
      console.error(
        `[client-view] optional section "${this.props.section || 'unnamed'}" failed and was hidden:`,
        error,
        info && info.componentStack,
      );
    } catch (_) { /* logging must never itself break the page */ }
  }

  render() {
    if (this.state.failed) return null;
    return this.props.children;
  }
}

export default SectionErrorBoundary;
